<template>
  <div class="navbar navbar-expand-lg navbar-light bg-light justify-content-between">
    <div class="container">
      <a class="navbar-brand" href="#/admin/">
        <img alt="Logo" height="40" src="../assets/logo.png">
      </a>
      <button aria-controls="togglerContent" aria-expanded="false" aria-label="Toggle navigation" class="navbar-toggler"
              data-bs-target="#togglerContent" data-bs-toggle="collapse" type="button">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div id="togglerContent" class="collapse navbar-collapse">
        <ul class="navbar-nav mr-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <router-link :to="{name: 'Messdiener'}" class="nav-link">Messdiener</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{name: 'Abmeldungen'}" class="nav-link">Abmeldungen</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{name: 'Messen'}" class="nav-link">Messen</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{name: 'Plaene'}" class="nav-link">Pläne</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{name: 'Medien'}" class="nav-link">Medien</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{name: 'EmailSend'}" class="nav-link">Email</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{name: 'Einstellungen'}" class="nav-link">Einstellungen</router-link>
          </li>
          <li v-if="this.authenticationStore.authenticated" class="nav-item">
            <VueAuthentication></VueAuthentication>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="container mt-3">
      <router-view v-if="this.authenticationStore.authenticated"></router-view>
      <VueAuthentication v-else></VueAuthentication>
    </div>
  </div>
</template>

<script>
import {useAuthenticationStore} from "@/stores/authentication";
import VueAuthentication from "@/components/Authentication.vue";

export default {
  name: 'AdminShell',
  components: {VueAuthentication},
  setup() {
    const authenticationStore = useAuthenticationStore();
    return {authenticationStore};
  },
}
</script>
